import React,{useState,useEffect,useRef,useContext} from "react";
import { FormatedPrice,SelectSeller,ControlAccess,CarouselImage} from "@gull"
import { useTranslate } from 'react-redux-multilingual'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye ,faEdit, faCommentAlt} from '@fortawesome/free-solid-svg-icons'
import { Badge,Modal } from "react-bootstrap";
import EditPriceModal from "./Component/EditPriceModal"
import NoteModal from "./Component/NoteModal"
import EditToPrepareModal from "./Component/EditToPrepareModal"
import axios from 'axios'
import swal from "sweetalert2";
import { promotions2Inputs,promotionsPrefixe,promotionsPosition } from 'app/allPromotions';
import DeleteLineButton from './Component/DeleteLineButton'
import { IsAuthContext } from 'app/App';

const LineItemParentSupplementPos = (props) =>{
    const t =useTranslate()
    const [qte,setQte]=useState(props.item.quantity)
    const [showEditPrice,setShowEditPrice]=useState(false)
    const [showEditToPrepare,setShowEditToPrepare]=useState(false)
    const [showNote,setShowNote]=useState(false)
    const [showComboDetail,setShowComboDetail]=useState(false)
    const [afterRestrcitionModifPrice,setAfterRestrcitionModifPrice]=useState(false) 
    const [loading,setLoading]=useState({
        delete:false,
        total:false
    })
    const [disabled,setDisabled]=useState(false)
    const [showRestriction,setShowRestriction]=useState(false) 
    const idsLocalStorage=localStorage.getItem("pos").split(',')
    const [showCarousel,setShowCarousel]=useState(false) 
    const { authParam } = useContext(IsAuthContext);
    const modulePos = authParam.modules.find(value=>value.name=='pos')

    const qteRef = useRef('')

    useEffect(function () {
        setQte(props.item.quantity)

    }, [props.currentTicket,props.item])
    
    let remise = (props.item.remise_combo == 0) ? false : <>- <FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.item.remise_combo} /></>

    let badgeTitle = (props.item.promotion!=null) ? t(props.item.promotion.type) : (props.item.details!= null && props.item.details.type=='percent') ? t('manualDiscountPercent') : (props.item.details!= null && props.item.details.type=='modif') ? t('priceModification') : t('manualDiscountNet')

    let promo = ''

    const combo_detail = (props.currentTicket?.ticket_detail) ? props.currentTicket.ticket_detail.filter(detail => (detail.combo && detail.combo_parent_id==props.item.id)) : []

    if(props.item.promotion!=null){
        if(promotionsPosition.includes(props.item.promotion.type)){
            promo = ' / -'+props.item.promotion.value[0]+'% ('+t('onPosition')+' '+(props.item.promotion.value[1] || 2)+')'

        }else if(promotions2Inputs.includes(props.item.promotion.type)){
            promo = ' / '+props.item.promotion.value[0]+' '+t('for')+' '+props.item.promotion.value[1]

        }else if(promotionsPrefixe.includes(props.item.promotion.type)){
            if(props.item.promotion.type=='percent'){
                promo = ' / '+'-'+props.item.promotion.value+'%'
            }else{
                promo = ' / '+'-'+props.item.promotion.value
            }
        }else{
            promo = props.item.promotion.value
        }

    }else if(props.item.details!=null && props.item.details.type=='percent'){
        promo = ' / '+'-'+props.item.details.value+'%'
    }

    const submit = async () =>{
        setLoading({...loading,total:true})
        setDisabled(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0],{
            quantity: qteRef.current.value,
            id:props.cookies.current_ticket,
            detail_id:props.item.id
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                props.setCurrentTicket(response.data.data)
                setLoading({...loading,total:false})
                setDisabled(false)
                
                let articleAfficheur = response.data.data.ticket_detail.sort((a,b) => b.id - a.id).find(value=>(value.article_id == props.item.article_id) && value.combo)
                
                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                    props.affichageClient(articleAfficheur.article.name,articleAfficheur.prix_combo,articleAfficheur.quantity,0,props.devise,t,props.peripheriqueParam)
                    //le 0 sur la variable 'raison' est passé pour définir que les infos ne concerne pas le total
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoading({...loading,total:false})
        props.setRelanceFocus(Date.now())
        props.setDisabledCloudButton(false)
    } 

    const showModal = (name) =>{
        if(name == 'price'){
            setShowEditPrice(true)
        }
        else if (name == 'to_prepare') {
            setShowEditToPrepare(true)
        }
        else{
            setShowNote(true)
        }
    }

    const callback = () =>{
        setAfterRestrcitionModifPrice(true)
    }

    const callbackRestriction = () =>{
        submit()
        setShowRestriction(false)
        props.setRestrictionRemoveQteLineItem({...props.restrictionRemoveQteLineItem,go:false})
    }

    const closeModal = (name) =>{
        if(name == 'price'){
            setShowEditPrice(false)
            if(afterRestrcitionModifPrice){ 
                props.setRestrictionModifPrix({...props.restrictionModifPrix,go:false})
                setAfterRestrcitionModifPrice(false)
            }
        }
        else if (name == 'to_prepare') {
            setShowEditToPrepare(false)
        }
        else{
            setShowNote(false)
        }
        props.setRelanceFocus(Date.now())
    }

    const closeRestricton = () =>{
        setQte(props.item.quantity)
        setShowRestriction(false)
        props.setDisabledCloudButton(false)
    }

    return(
        <>
            <Modal show={showCarousel} onHide={()=>setShowCarousel()}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.item.article && props.item.article.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(props.item.article && props.item.article.image) ?
                        <CarouselImage images={props.item.article.image} />
                    :
                        <div></div>
                    }
                </Modal.Body>
            </Modal>
            <Modal show={showRestriction} onHide={()=>closeRestricton()}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{marginTop:'80px'}}>
                        <ControlAccess section={props.section} focus={true} restriction={props.restrictionRemoveQteLineItem} moduleId={props.posid} setRestriction={props.setRestrictionRemoveQteLineItem} callback={callbackRestriction} />
                    </div>
                </Modal.Body>
            </Modal>
            <NoteModal 
                showNote={showNote}
                closeModal={closeModal}
                posid={props.posid}
                cookies={props.cookies}
                currentTicket={props.currentTicket}
                setCurrentTicket={props.setCurrentTicket}
                lineId={props.lineId}
                item={props.item}
                module='pos'
            />
            <EditPriceModal 
                title={t('priceEdit')}
                showEditPrice={showEditPrice}
                closeModal={closeModal}
                cookies={props.cookies}
                item={props.item}
                setCurrentTicket={props.setCurrentTicket}
                setDisabledPay={props.setDisabledPay}
                section={props.section}
                posid={props.posid}
                restrictionModifPrix={props.restrictionModifPrix}
                setRestrictionModifPrix={props.setRestrictionModifPrix}
                callback={callback}
                affichageClient={props.affichageClient}
                peripheriqueParam={props.peripheriqueParam}
                module='pos'
                groupId={[]}
                forGroup={false}
                authParam={authParam}
            />
            <EditToPrepareModal
                showEditToPrepare={showEditToPrepare}
                closeModal={closeModal}
                posid={props.posid}
                cookies={props.cookies}
                currentTicket={props.currentTicket}
                setCurrentTicket={props.setCurrentTicket}
                lineId={props.lineId}
                item={props.item}
                module='pos'
            />
            <div className={props.style + ' comboLine'}>
                <div className="row">
                    <div className="col-8">
                        <div className="row">
                            <strong className="fsArticlePos">{(props.item.article.sku) ? props.item.article.sku+' '+props.item.article.name : props.item.article.name}</strong> 
                        </div>
                        <div className="row marginLeftArticle">
                            <div className="col-3 offset-1 m-0 p-0 input-group-sm" style={{zIndex:'999'}}>
                                <input ref={qteRef} disabled={true} className='form-control' value={qte} type="text"/>
                            </div>
                            <div className="col-8 pl-1 m-0 pb-0 pt-1 zIndexBtnNotePos">
                                <button disabled={disabled} className="btn btn-primary btn-sm sizeBtnPos" onClick={()=>showModal('price')}><FontAwesomeIcon icon={faEdit} /></button>&nbsp;
                                <button className="btn btn-primary btn-sm sizeBtnPos" onClick={()=>showModal('note')}><FontAwesomeIcon icon={faCommentAlt} /></button>&nbsp;
                                {(modulePos.params?.to_prepare?.active) &&
                                    (props.item.article.to_prepare) && 
                                        <button className="btn btn-warning btn-sm sizeBtnPos" onClick={()=>showModal('to_prepare')} style={{ fontWeight:'bold' }}>{props.item.to_prepare_qty}</button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        {(props.item.article && props.item.article.image) ?
                            <div className='text-end mb-1' style={{maxHeight:'60px'}}>
                                <img className="pointer" style={{maxHeight:'50px', maxWidth:'70px'}} src={props.item.article.image.split(';')[0]} alt={props.item.article.name} onClick={()=>setShowCarousel(true)}/>
                            </div>
                        :
                            <div className='text-end mb-1' style={{maxHeight:'60px'}}>
                                <img style={{maxHeight:'50px', maxWidth:'70px'}} src="/assets/images/no-image.png" alt="No image" />
                            </div>
                        }
                    </div>
                </div>
                <div className="row marginLeftArticle mt-1">
                    <div className="col-4">
                        <div className="row">
                            <div className="col-9 m-0 p-0 zIndexBtnNotePos">
                                <span className="priceArticlePos">{<FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.item.prix_combo} />}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 m-0 p-0">
                        <SelectSeller 
                            section={props.section} 
                            cookies={props.cookies}
                            item={props.item}
                            lineId={props.item.id}
                            posid={props.posid}
                            currentTicket={props.currentTicket}
                            setCurrentTicket={props.setCurrentTicket} 
                            setRelanceFocus={props.setRelanceFocus}
                            from='pos'//à passer pour obligatoirement pour connaitre les options de son module 
                        />
                    </div>
                    <div className="col-4">
                        <div className="text-end m-0 p-0 priceArticlePos totalPricePosition">
                            {(loading.total) ?
                                <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span>
                            :
                                <FormatedPrice langRegion={'fr-FR'} devise={props.devise} digit={props.digit} priceToFormat={props.item.prix_combo} />
                            }
                        </div>
                        <span className="m-0 p-0 crossPosition">
                            {(loading.delete) ?
                                    <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span>
                                :
                                    <DeleteLineButton
                                        setLoading={setLoading}
                                        loading={loading}
                                        setDisabledPay={props.setDisabledPay}
                                        posid={props.posid}
                                        idsLocalStorage={idsLocalStorage}
                                        item={props.item}
                                        cookies={props.cookies}
                                        setCurrentTicket={props.setCurrentTicket}
                                        setRelanceFocus={props.setRelanceFocus}
                                        from='lineItem'
                                        restrictionDeleteLineItem={props.restrictionDeleteLineItem}
                                        setRestrictionDeleteLineItem={props.setRestrictionDeleteLineItem}
                                        section={props.section} 
                                        affichageClient={props.affichageClient}
                                        peripheriqueParam={props.peripheriqueParam}
                                    />
                            }
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        {(remise) ?
                            <Badge bg="warning" text="dark">{badgeTitle+promo+' / '}<span>{remise}</span></Badge>
                        :
                            (props.item.details!=null && props.item.details.type=='modif') ? 
                                <Badge bg="warning" text="dark">{badgeTitle}</Badge>
                            :
                                false
                        }
                    </div>
                    <div className="col-auto">
                        <button disabled={disabled} className="btn btn-primary btn-sm sizeBtnPos" onClick={() => setShowComboDetail(prev => !prev)}><FontAwesomeIcon icon={faEye} /></button>&nbsp;
                    </div>
                </div>
                {showComboDetail &&
                    <div className="row">
                        {combo_detail.length>0 && combo_detail.map((value) => {
                                return (
                                    <div key={value.id} className="row">
                                        <div className="col">{value.article.name}</div>
                                        <div className="col-1">{value.quantity}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
        </>
    )
}

export default LineItemParentSupplementPos;